import React, { useState } from "react";
import { Card, Flex, Space } from "antd";
import { KeyOutlined, RightOutlined } from "@ant-design/icons";
import { useThemeContext } from "../../../context/ThemeContext";
import IcomingCalls from "../IncomingCalls";
import OutgoingCalls from "../OutgoingCalls";
import MinutesUsage from "../MinutesUsage";
import SettingsSidebarHeader from "../../../components/common/SettingsSidebarHeader";
import GradientButton from "../../../components/common/UI/GradientButton";
import "./index.scss";

const options = [
  {
    id: "1",
    name: "Incoming Calls",
    number: "+971345678",
    icon: "incoming",
  },
  {
    id: "2",
    name: "Outgoing call",
    icon: "outgoing",
  },
  {
    id: "3",
    name: "Minutes usage",
    icon: "vector",
  },
];

interface CallHandlingProps {
  handleBackToPrevious: () => void;
}

const CallHandling: React.FC<CallHandlingProps> = ({
  handleBackToPrevious,
}) => {
  const [currentScreen, setCurrentScreen] = useState("call-handling");
  const { theme } = useThemeContext();

  const getScreenBasedOnItem = (item: any) => {
    if (item.id === "1") {
      return "incoming-calls";
    } else if (item.id === "2") {
      return "outgoing-calls";
    } else if (item.id === "3") {
      return "minutes-usage";
    } else {
      return "call-handling";
    }
  };

  const handleNextScreen = (screen: string, id: string) => {
    setCurrentScreen(screen);
  };

  const handleBackToCallHandling = () => {
    setCurrentScreen("call-handling");
  };

  const getIconComponent = (iconName: string) => {
    switch (iconName) {
      case "incoming":
        return (
          <img
            src={`/assets/icons/${theme}/incoming-call.png`}
            alt="incoming-call"
            width={20}
            height={20}
          />
        );
      case "outgoing":
        return (
          <img
            src={`/assets/icons/${theme}/outgoing-call.png`}
            alt="outgoing-call"
            width={20}
            height={20}
          />
        );
      case "vector":
        return (
          <img
            src={`/assets/icons/${theme}/minutes-usage.png`}
            alt="vector"
            width={20}
            height={20}
          />
        );
      default:
        return <KeyOutlined style={{ fontSize: "16px" }} rotate={320} />;
    }
  };

  return (
    <>
      {currentScreen === "call-handling" && (
        <div className="call-handling-container">
          <SettingsSidebarHeader
            title="Call Handling"
            handleBackClick={handleBackToPrevious}
          />

          <div className="options-container">
            {options.map((item) => (
              <Card
                key={item.id}
                onClick={() =>
                  handleNextScreen(getScreenBasedOnItem(item), item.id)
                }
                bordered={false}
                className="option-card"
                styles={{ body: { padding: "10px" } }}
              >
                <Flex align="center" justify="space-between">
                  <Space size={10}>
                    <GradientButton className="option-icon">
                      {getIconComponent(item.icon)}
                    </GradientButton>
                    <h6 className="option-title">{item.name}</h6>
                  </Space>

                  <RightOutlined className="right-icon" />
                </Flex>
              </Card>
            ))}
          </div>
        </div>
      )}

      {currentScreen === "incoming-calls" && (
        <IcomingCalls handleBackToPrevious={handleBackToCallHandling} />
      )}

      {currentScreen === "outgoing-calls" && (
        <OutgoingCalls handleBackToPrevious={handleBackToCallHandling} />
      )}

      {currentScreen === "minutes-usage" && (
        <MinutesUsage handleBackToPrevious={handleBackToCallHandling} />
      )}
    </>
  );
};

export default CallHandling;
